import React,{useReducer} from 'react';
import alertaReducer from './alertaReducer';
import alertaContenxt from './alertaContext';
import {MOSTRAR_ALERTA,OCULTAR_ALERTA} from '../../types';

const AlertaState = props => {
    const initialState={
        alerta: null
    }

    const [state, dispatch] = useReducer(alertaReducer,initialState);

    //funciones

    const mostrarAlerta= (msg,categoria)=>{
       dispatch({
           type: MOSTRAR_ALERTA,
           payload:{
               msg,
               categoria
           }
       });
       
       //despues de 5s limpia el alerta
       setTimeout(() => {
        dispatch({
            type: OCULTAR_ALERTA,
        });

       }, 5000);
    }

    return (  

        <alertaContenxt.Provider
            value={{
                alerta: state.alerta,
                mostrarAlerta
            }}
        >
            {props.children}
        </alertaContenxt.Provider>

    );
}
 
export default AlertaState;